import * as types from './actionTypes';
import initialState from './initialState';

const rulesActionsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_RULES_ACTIONS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_RULES_ACTIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: action.payload.rulesActions,
            count: action.payload.count,
          },
        },
      };
    case types.GET_RULES_ACTIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.ADD_RULES_ACTION_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: true,
        },
      };
    case types.ADD_RULES_ACTION_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
        },
      };
    case types.ADD_RULES_ACTION_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.GET_RULES_ACTION_REQUEST:
      return {
        ...state,
        show: {
          ...state.show,
          isLoading: true,
        },
      };
    case types.GET_RULES_ACTION_SUCCESS:
      return {
        ...state,
        show: {
          ...state.show,
          data: action.payload.rulesAction,
          isLoading: false,
        },
      };
    case types.GET_RULES_ACTION_ERROR:
      return {
        ...state,
        show: {
          ...state.show,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_RULES_ACTION_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: true,
        },
      };
    case types.UPDATE_RULES_ACTION_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
        },
      };
    case types.UPDATE_RULES_ACTION_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_RULES_ACTION_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
        },
      };
    case types.DELETE_RULES_ACTION_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
        },
      };
    case types.DELETE_RULES_ACTION_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_RULES_ACTIONS_PAGINATION_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: action.payload.paginationOptions,
        },
      };
    default:
      return state;
  }
};

export default rulesActionsReducer;
